
import page from "~/layouts/blog.vue";

export default {
  components: {
    page,
  },

  head() {
    return {
      title:
        "Quand poster sur Instagram en 2026 : les moments clés à connaître",
      meta: [
        {
          hid: "description",
          name: "description",
          content:
            "Découvrez les meilleurs moments pour poster sur Insta en 2026 et maximiser votre engagement, en tenant compte des dernières tendances et habitudes des utilisateurs.",
        },
        {
          hid: "og:title",
          property: "og:title",
          content: "Quand poster sur Instagram en 2026 : Les meilleurs moments",
        },
        {
          hid: "og:description",
          property: "og:description",
          content:
            "En 2026, Instagram continue de régner en tant que l’une des plateformes de médias sociaux les plus influentes, avec des milliards d’utilisateurs actifs à travers le monde.",
        },
      ],
    };
  },
};
